import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import {
  BOOKMARK_CODE_PATTERN,
  normalizeBookmarkCode,
} from "@bindery/shared/contracts/study";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const ORIENTATION_SESSIONS_PATH = `${ORIENTATION_API_PREFIX}/sessions`;

// The body names how to find the reader, never the reader (design review
// H2): a typed readerId would let any aide open a session on any child.
export const createSessionRequestSchema = z.union([
  z.strictObject({
    bookmarkCode: z
      .string()
      .max(32)
      .overwrite(normalizeBookmarkCode)
      .regex(BOOKMARK_CODE_PATTERN),
  }),
  z.strictObject({ funnelId: z.string().regex(UUID_REGEX) }),
]);
export type CreateSessionRequest = z.input<typeof createSessionRequestSchema>;

export const createSessionResponseSchema = z.object({
  sessionId: z.string().regex(UUID_REGEX),
});
export type CreateSessionResponse = z.infer<typeof createSessionResponseSchema>;
